import CalendarIcon from "@/components/Elements/Filters/CalendarIcon";

import DateRangeFilterDropdown from "./DateRangeFilterDropdown";

export default {
  filterDropdown: DateRangeFilterDropdown,
  filterIcon: CalendarIcon,
};
